module.exports = __webpack_public_path__ + "img/文字版.611f7ec8.png";